import Color from "colorjs.io";

export function brigtenColor(color, amount) {
    const c = new Color(color);
    const values = [c.toString({format: "hex"})];

    for (let i = 0; i < amount; i++) {
        c.lighten(0.1);
        values.push(c.toString({format: "hex"}));
    }

    return values;
}

export function darkenColor(color, amount) {
    const c = new Color(color);
    const values = [c.toString({format: "hex"})];

    for (let i = 0; i < amount; i++) {
        c.darken(0.1);
        values.push(c.toString({format: "hex"}));
    }

    return values;
}